import classNames from 'classnames'
import React from 'react'

const Loader = ({ size = 'large', color = 'blue', label = '' }) => {
  const loaderClass = classNames('animate-spin rounded-full border-t-4', {
    'w-16 h-16 border-4': size === 'large',
    'w-12 h-12 border-4': size === 'medium',
    'w-8 h-8 border-4': size === 'small',

    'border-t-blue-500 border-gray-300': color === 'blue',
    'border-t-green-500 border-gray-300': color === 'green',
    'border-t-red-500 border-gray-300': color === 'red'
  })

  const labelClass = classNames('m-6', {
    'text-blue-500': color === 'blue',
    'text-green-500': color === 'green',
    'text-red-500': color === 'red',

    'text-xl': size === 'large',
    'text-lg': size === 'medium',
    'text-sm': size === 'small'
  })

  return (
    <div className="flex items-center justify-center mb-8">
      <div className={loaderClass}></div>
      {label && <span className={labelClass}>{label}</span>}
    </div>
  )
}

export default Loader
